import React, { useEffect, useState } from 'react';

export default function InstituteNameList({ NameList }) {

    const[list, setList] = useState([]);

    useEffect(()=>{
        if (NameList === undefined) {
            setList([]);
        } else {
            setList(NameList);
        };
    },[NameList]);
    

    return (
        <div>
            {
                list.map((val, i) =>
                    <span key={i}>{(i ? ', ' : '') + val}</span>
                )
            }
        </div>
    )
};